<template>
  <FKBreadCrumb :page="$t('page.centers')" />
  <CentersList /> 
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CentersList from "@/components/FK/Center/CentersList.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";

export default defineComponent({
  name: "CentersPage",
  components: {
    FKBreadCrumb,
    CentersList,
  },
});
</script>